import { REPORTS_LIST_QUERY } from "@/components/customerView/reports/graphql/queries";
import { hasReportEntitlement } from "@/components/reports/reportListClick";
import { useQuery } from "@apollo/client";

import { useAppState } from "./AppStateProvider";
import SliderTabs from "./SliderTabs";

export default function CustomerTabs({ selectedTab }) {
  const { userInfo } = useAppState();
  const user = userInfo?.user;

  const { data: reportsData } = useQuery(REPORTS_LIST_QUERY, {
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !user
  });

  const showReportsTab =
    !!user &&
    !!reportsData &&
    hasReportEntitlement({
      reports: reportsData.reports,
      userEntitlements: user.entitlements
    });

  const tabs = [
    {
      label: "profile",
      urlTemplate: "/profile"
    },
    {
      label: "orders",
      urlTemplate: "/orders"
    },
    {
      label: "test results",
      urlTemplate: "/test-results"
    },
    ...(showReportsTab
      ? [
          {
            label: "reports",
            urlTemplate: "/reports"
          }
        ]
      : []),
    {
      label: "questionnaire",
      urlTemplate: "/questionnaire"
    },
    {
      label: "suggestions",
      urlTemplate: "/suggestions",
      disabled: true
    },
    {
      label: "food list",
      urlTemplate: "/food-list",
      disabled: true
    }
  ];

  return (
    <SliderTabs
      data-component-name="CustomerTabs"
      tabs={tabs}
      selectedTab={selectedTab}
      withBorder
    />
  );
}
